import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';

const CAMPCompleteReport = () => {
  const tableRef = useRef(null);
  const [campData, setCampData] = useState([]);
  const authToken = localStorage.getItem("authToken");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCampData = async () => {
      try {
        console.log("Fetching camp data...");
        const response = await fetch(
          //"http://localhost:5121/api/CampRegistration/CampRegistrationReport",
          "https://apiv2.chakran.in/api/CampRegistration/CampRegistrationReport",
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch camp records");

        let data = await response.json();

        // Add SrNo to each record
        data = data.map((record, index) => ({
          ...record,
          SrNo: index + 1,
        }));

        setCampData(data);
      } catch (error) {
        console.error("Error fetching camp data:", error);
      }
    };

    fetchCampData();
  }, []);


    // Function to update status
  const handleStatusChange = async (registrationNo, newStatus) => {
    const comment = prompt("Enter comment for this status change:");
    if (!comment) return; // Optional: require comment

    try {
        const authToken = localStorage.getItem("authToken");
  
        const response = await fetch(`https://apiv2.chakran.in/api/CampRegistration/updateStatus/${registrationNo}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({ status: newStatus, comment }),
        });
  
        if (!response.ok) throw new Error("Failed to update status");
 
        // Update state only after successful API call
        setCampData(prev =>
            prev.map(row =>
              row.registrationNo === registrationNo
                ? { ...row, status: newStatus, comment }
                : row
            )
          );
      
    } catch (error) {
        console.error("Error updating status:", error);
    }
  };

  const successRejectData = campData.filter(r => r.status === "Complete" || r.status === "Rejected" || r.status === "Refunded");
  useEffect(() => {
    if (tableRef.current && successRejectData.length > 0) {
      const table = $(tableRef.current).DataTable({
          destroy: true, // Destroy existing table instance
          data: successRejectData,
          columns: [
          { data: 'SrNo', title: 'Sr No' },
          { data: 'startDate', title: 'Date' },
          { data: 'name', title: 'Organizer Name' },
          { data: 'organizerContactNo', title: 'Organizer Contact' },
          { data: 'registrationNo', title: 'Registration No' },
          { 
            data: 'status', 
            title: 'Status',
            render: function (data, type, row) {
                const getStatusColor = (status) => {
                    switch(status) {
                        case 'In Progress': return '#17a2b8';
                        case 'Complete': return '#28a745';
                        case 'Rejected': return '#dc3545';
                        case 'Refunded': return '#ffc107';
                        default: return '#6c757d';
                    }
                };
                
                return `
                  <div className="custom-status-dropdown" data-id="${row.registrationNo}">
                    <div className="status-display" style="background-color: ${getStatusColor(data)}; color: ${data === 'In Progress' ? '#000' : '#fff'}; padding: 5px 10px; border-radius: 4px; cursor: pointer; text-align: center; font-weight: bold;">
                      ${data}
                    </div>
                    <select className="form-control status-dropdown" data-id="${row.registrationNo}" style="display: none;">
                      <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                      <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                      <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                      <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                    </select>
                  </div>
                `;
            }
          },
          { data: 'comment', title: 'Comment' } ,
          { data: 'EditForm', title: 'Edit Form',  
            render: (data, type, row) => {   
            return `
                <button className="btn btn-sm btn-primary edit-btn"
                        data-id="${row.id}"
                        data-name="${row.name}"
                        data-contact="${row.organizerContactNo || ''}">
                  Edit
                </button>
              `;
          } 
        }
        ],
      });
      $('#productsTable tbody').on('click', 'button.edit-btn', function () {
        const id = $(this).data('id');
        const organizerName = $(this).data('name');
        const organizerContactNo = $(this).data('contact');

        // ✅ Log the extracted values
        console.log("Clicked Edit Button");
        console.log("CampRegistrationId:", id);
        console.log("Organizer Name:", organizerName);
        console.log("Organizer Contact No:", organizerContactNo);

        // ✅ Save values in localStorage
        localStorage.setItem("campRegistrationId", id);
        localStorage.setItem("organizationName", organizerName);
        localStorage.setItem("organizerContactNo", organizerContactNo);

        console.log("Values saved in localStorage");

        // ✅ Redirect to Add Applicants form
        navigate("/dashboard/add-applicants");
      });



      // Handle custom status dropdown click
      $(tableRef.current).on("click", ".status-display", function () {
        const registrationNo = $(this).closest('.custom-status-dropdown').attr("data-id");
        $(this).siblings('.status-dropdown').show().focus();
      });

      // Handle status change
      $(tableRef.current).on("change", ".status-dropdown", function () {
        const registrationNo = $(this).attr("data-id");
        const newStatus = $(this).val();
        const comment = ""; // Or however you get it
        
        // Update the display
        const statusDisplay = $(this).siblings('.status-display');
        const getStatusColor = (status) => {
            switch(status) {
                case 'In Progress': return '#17a2b8';
                case 'Complete': return '#28a745';
                case 'Rejected': return '#dc3545';
                case 'Refunded': return '#ffc107';
                default: return '#6c757d';
            }
        };
        
        statusDisplay.text(newStatus);
        statusDisplay.css({
            'background-color': getStatusColor(newStatus),
            'color': newStatus === 'In Progress' ? '#000' : '#fff'
        });
        
        $(this).hide();
        handleStatusChange(registrationNo, newStatus, comment);
      });

      // Hide dropdown when clicking outside
      $(document).on("click", function(e) {
        if (!$(e.target).closest('.custom-status-dropdown').length) {
          $('.status-dropdown').hide();
        }
      });


      return () => {
              table.destroy();
      };

    }
  }, [campData]); // Re-run when campData updates

  return (

          <table
            ref={tableRef}
            id="productsTable"
            className="table table-bordered table-hover table-product"
            style={{ width: '100%' }}
          >
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Date</th>
                <th>Name</th>
                <th>Organizer Contact</th>
                <th>Registration No</th>
                <th>Status</th>
                <th>Comment</th>
                <th>Edit</th>
              </tr>
            </thead>
          </table>
        
  );
};

export default CAMPCompleteReport;
